import { CountryApiModel } from '@cxb/editor-stb-api';
import { Country } from '../../domain/country';

export const mapCountryApiModelsToCountryDomains = (countryApiModels: CountryApiModel[]): Country[] => {
  return countryApiModels.map((country) => ({ id: country.id, name: country.countryName, iso2Code: country.iso2Code }));
};
